const React = require('react');

const IconWrapper = require('../IconWrapper');

const UserShippingReview = ({ className, isRebrand } = {}) => (
  <IconWrapper>
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || 'with-custom-color'}
    >
      <rect y="0.5" width="40" height="40" rx="20" fill="white" />
      <rect
        x="0.5"
        y="1"
        width="39"
        height="39"
        rx="19.5"
        stroke="black"
        stroke-opacity="0.07"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.999 24.25C23.7275 24.25 26.75 21.2275 26.75 17.499C26.75 13.7706 23.7275 10.748 19.999 10.748C16.2705 10.748 13.248 13.7706 13.248 17.499C13.248 21.2275 16.2705 24.25 19.999 24.25ZM19.999 22.75C17.099 22.75 14.748 20.3991 14.748 17.499C14.748 14.599 17.099 12.248 19.999 12.248C22.899 12.248 25.25 14.599 25.25 17.499C25.25 20.3991 22.899 22.75 19.999 22.75Z"
        fill="black"
        fill-opacity="0.9"
      />
      <path
        d="M13.9804 27.25C12.7486 27.25 11.75 28.2487 11.75 29.4805V30.2305H10.25V29.4805C10.25 27.4202 11.9202 25.75 13.9804 25.75H26C28.0711 25.75 29.75 27.429 29.75 29.5V30.25H28.25V29.5C28.25 28.2574 27.2426 27.25 26 27.25H13.9804Z"
        fill="black"
        fill-opacity="0.9"
      />
    </svg>
  </IconWrapper>
);

module.exports = React.memo(UserShippingReview);
